import classNames from 'classnames';
import * as classes from './Display.css';
import { AriaRole, ComponentProps } from 'react';
import BaseTypography from '../BaseTypography';
import { Filter } from '@/types/app.type';


export interface DisplayProps {
  id?: string;
  'data-test-id'?: string;
  /**
   * Define the content of the Display.
   * @type string
   * @required
   */
  children?: string;
  /**
   * Define the content of the Display.
   * @type string
   * @required
   */
  text?: string;
  /**
   * Define the color of the Display.
   * @type ComponentProps<typeof BaseTypography>['color'];
   * @optional
   */
  color?: ComponentProps<typeof BaseTypography>['color'];
  /**
   *  Define the custom className.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * Define the font size of the Display.
   * @type "s" | "m" | "l" | "xl"
   * @required
   */
  size: 's' | 'm' | 'l' | 'xl';
  /**
   * Define the font style of the Display.
   * @type string
   * @optional
   */
  fontStyle?: string;
  /**
   * Define the Display role.
   * @type "presentation" | "none"
   * @optional
   */
  role?: Filter<AriaRole, 'presentation' | 'none'>;
  /**
   *  Define the component type.
   * @type "h1" | "h2" | "h3" | "h4"| "h5" | "label" | "time" | "p" | "span"
   * @optional
   */
  /**
   * Hide Display Component.
   * @type string
   * @optional
   */
  hide?: boolean;
  component?: keyof Pick<React.JSX.IntrinsicElements, 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'label' | 'time' | 'p' | 'span'>;
  /**
   * The label for if associated with an input.
   * @type string
   * @optional
   */
  htmlFor?: string;
  /**
   * Enable animation triggered whe the element is visible.
   * @type boolean
   * @optional
   */
  animated?: boolean;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animation?: string;
  /**
   * The animation type triggered whe the element is visible. Default is fadeIn
   * @type string
   * @optional
   */
  animationType?: string;
}

export function Display(props: DisplayProps) {
  // console.log("Component Display ===== ", props?.component)
  return (
    <>
      {!props?.hide && <BaseTypography
        htmlFor={props.htmlFor}
        data-test-id={props['data-test-id']}
        role={props.role ?? 'presentation'}
        // component={["main", "nav", "span", "p", "label", "h4", "h5", "h1", "h2", "h3", "h6", "div", "button", "form", "input", "ol", "ul", "select", "checkbox", "radio", "li"].includes(props.component || "") ? props.component || "span" : 'span'}
        component={props.component ?? 'span'}
        color={props.color}
        style={{
          fontFamily: !props?.fontStyle ? 'livelyHeadline, sans-serif' : props?.fontStyle === "default" ? 'livelyHeadline, sans-serif' : `${props?.fontStyle}, sans-serif`,
        }}
        className={classNames(
          classes.variant[props.size], 
          props.className
        )}
        animated={props.animated ?? false}
        animation={(props.animation || props.animationType) ?? ''}
        id={props.id}
      >
        {props.text || props.children}
      </BaseTypography>}
    </>
  );
}


// Tailwind Font approach -- (avoid)
        // {
        //   [`font-${classes.base}`] : props?.fontStyle === "display",
        //   [`font-${props?.fontStyle}`]: props?.fontStyle !== "display"
        // },
        // props?.fontStyle ? `font-${props?.fontStyle}` : `font-${classes.base}`, 
        // props?.fontStyle ? `font-${props?.fontStyle}` : 'font-display', 